var EditChannelRequestModel = /** @class */ (function () {
    function EditChannelRequestModel() {
    }
    return EditChannelRequestModel;
}());
export { EditChannelRequestModel };
